import { CallEvent } from '../types';
import IWebPhoneService from '../IWebPhoneService';
import appManager from '@app/appManager';
import IAppLogger from '@app/lib/IAppLogger';

const handleCallMissed = (
  webPhoneService: IWebPhoneService,
  newCallEvent: CallEvent,
  logger: IAppLogger,
) => {
  logger.info(
    `Call missed: ${newCallEvent.callId}`,
    newCallEvent,
    webPhoneService,
  );

  appManager.events.emit('phone.call.missed', newCallEvent);
};

export default handleCallMissed;
